const setPageTitleWithBreadcrumbData = (breadCrumbList) => {
  if (breadCrumbList.length > 0) {
    let pageTitle = '';
    breadCrumbList.forEach((item, index) => {
      if (index === 0) pageTitle = item.title;
      else pageTitle = `${item.title} - ${pageTitle}`;
    });
    setPageTitle(pageTitle);
  }
};

const setPageTitle = (title) => {
  if (title)
    document.title =
      window.staticData && window.staticData.tenantName && window.staticData.tenantName !== ''
        ? `${title} - ${window.staticData.tenantName}`
        : `${title} - SumTotal`;
};

export { setPageTitleWithBreadcrumbData, setPageTitle };
